<script>
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";
import { storesMethods, authComputed } from "@state/helpers";
export default {
  name: "UsersCreateForm",
  props: {
    onFormSubmit: {
      type: Function,
      required: true,
    },
    //     validator: {
    //       type: Object,
    //       required: true,
    //     },
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // add this for change input type
    };
  },
  validations: {
    createForm: {
      name: {
        required,
        minLength: minLength(4),
      },
      address: {
        required,
        minLength: minLength(4),
      },
    },
  },
};
</script>
<template>
  <b-form id="form" @submit="onFormSubmit">
    <form-wrapper :validator="$v.createForm">
      <div>
        <form-summary />
      </div>
      <form-group name="name" :label="$t('name')">
        <b-form-input
          v-model="form.name"
          autocomplete="off"
          slot-scope="{ attrs, listeners }"
          v-bind="attrs"
          v-on="listeners"
        />
      </form-group>
      <form-group name="address" :label="$t('address')">
        <b-form-input
          v-model="form.address"
          type="text"
          autocomplete="off"
          slot-scope="{ attrs, listeners }"
          v-bind="attrs"
          v-on="listeners"
        />
      </form-group>
    </form-wrapper>
  </b-form>
</template>
